module.exports = __webpack_public_path__ + "static/media/fiets.de8d44e3.png";